import { /* useContext, */ useMemo } from "react";

import { useDatastoreStore } from "hooks/datastores/useDatastoresStore";
import { Datastore } from "utils/types/datastores";
import { MenuItem } from "utils/types/menu";

// import { DemoContext } from "contexts/demo";
// import response from "./response.json";

export interface Type {
  [key: string]: {
    items: MenuItem[];
  };
}

export interface Categories {
  [key: string]: Type;
}

export const useDatastoreTypes = () => {
  // const { isDemo } = useContext(DemoContext);
  const isLoading = useDatastoreStore((s) => s.loading);
  const datastore_types = useDatastoreStore((s) => s.datastoreTypes);

  const categoriesObj: Categories = useMemo(() => {
    const newCategoriesObj: Categories = {};

    datastore_types?.forEach((datastore_type: Datastore) => {
      const { category, type } = datastore_type;
      if (!category || !type) return;

      if (!newCategoriesObj[category]) newCategoriesObj[category] = {};
      newCategoriesObj[category][type] = { items: [] as MenuItem[] };
    });

    return newCategoriesObj;
  }, [datastore_types]);

  const result = useMemo(() => Object.entries(categoriesObj), [categoriesObj]);

  return { res: result, isLoading, error: undefined };
};
